'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Layout).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return Layout;
}(_react.Component);

var createLayout = function createLayout(superclass, _ref) {
  var trace = _ref.trace;
  var title = _ref.title;
  var nav = _ref.nav;
  var useNav = _ref.useNav;
  return function (_superclass) {
    _inherits(_class, _superclass);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'initial',
      value: function initial() {
        this.filterHeader();
      }
    }, {
      key: 'filterHeader',
      value: function filterHeader() {
        if (trace.length > 1) {
          this.header = [{ name: title, to: nav[0].to }].concat(trace);
        } else {
          this.headerNav = useNav ? nav : [{ name: title }];
        }
      }
    }]);

    return _class;
  }(superclass);
};

var filterRule = function filterRule(routes, trace, rootPath) {
  var result = [];
  routes.forEach(function (item, index) {
    if (trace) {
      item.trace = trace.concat({
        to: rootPath + '/' + item.path,
        name: item.name
      });
    } else {
      item.trace = [{
        to: index === 0 ? item.path : rootPath + '/' + item.path,
        name: item.name
      }];
    }

    result.push(item);

    if (item.children) {
      result = result.concat(filterRule(item.children, item.trace, rootPath));
    }
  });
  return result;
};

var filterNav = function filterNav(routes) {
  return routes.map(function (item, index) {
    return {
      to: index === 0 ? item.path : routes[0].path + '/' + item.path,
      name: item.name
    };
  });
};

var App = function (_Component2) {
  _inherits(App, _Component2);

  function App() {
    var _Object$getPrototypeO;

    var _temp, _this3, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(App)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this3), _this3.rules = {}, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(App, [{
    key: 'render',
    value: function render() {
      var _rules = this.rules;
      var routes = _rules.routes;
      var title = _rules.title;
      var useNav = _rules.useNav;

      var ruleList = filterRule(routes, false, routes[0].path);
      var root = ruleList.shift();
      var nav = filterNav(routes);

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: _reactRouter.browserHistory },
        _react2.default.createElement(
          _reactRouter.Route,
          { path: root.path, component: Layout },
          _react2.default.createElement(_reactRouter.IndexRoute, { component: createLayout(root.component, { trace: root.trace, title: title, nav: nav, useNav: useNav }) }),
          ruleList.map(function (item) {
            return _react2.default.createElement(_reactRouter.Route, {
              key: item.path,
              path: item.path,
              component: createLayout(item.component, { trace: item.trace, title: title, nav: nav, useNav: useNav })
            });
          })
        )
      );
    }
  }]);

  return App;
}(_react.Component);

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rs-page/lib/pages/PageRouter.js
// module id = 1360
// module chunks = 0